import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    subdomain: "hotgloo", 
    customerName: "",
    plan_uid: null,
    email: "", 
    account_uid: null, 
    user_country: 'Germany',
    user_account_type: 'company', 
    calculated_price: null,  
    account_id: null, 
    cus_id : null, 
    coupon: "", 
    coupon_valid: 1, 
    success_url: null, 
    cancel_url: null, 
    cus_exists: false,  
    cus_data: {}, 

  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
